import(/* webpackMode: "eager", webpackExports: ["SpacePublicComponent"] */ "/home/runner/work/web-public/web-public/components/pages/space-public.js");
